__turbopack_context__.v({
  "menuToggle": "header-module__ilLclq__menuToggle",
  "mobNav": "header-module__ilLclq__mobNav",
  "mobNavClosed": "header-module__ilLclq__mobNavClosed",
  "mobNavOpen": "header-module__ilLclq__mobNavOpen",
  "mobNavOpen1": "header-module__ilLclq__mobNavOpen1",
  "mobNavOpen2": "header-module__ilLclq__mobNavOpen2",
  "mobNavOpen3": "header-module__ilLclq__mobNavOpen3",
});
